import { queryTable, Table } from 'common/types/disco/table';

type Weighted = {
  id: string;
  weights: number[];
};

/**
 * Pulls out an `id` field and a `weights` array from each row.
 *
 * @param table      - Table from which to read data
 * @param location   - The column to use as the `id`
 * @param weightCols - Columns to pack into the `weights` array
 */
export function extractWeights(
  data: Table | undefined,
  location: string,
  weightCols: string[],
): Weighted[] {
  if (!data) return [];
  const query = queryTable(data);
  const locationIndex = query.columnIndices(location)[0];
  const weightIndices = query.columnIndices(...weightCols);

  return data.rows.map(row => {
    const id = row[locationIndex];

    const weights = weightIndices.map(colIdx => {
      const raw = row[colIdx];
      const num = typeof raw === 'number' ? raw : parseFloat(raw);
      return Number.isNaN(num) ? 0 : num;
    });

    return { id, weights };
  });
}
